var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompassOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9173 16.0001C27.9173 23.1028 22.3433 28.8334 15.5007 28.8334C8.65796 28.8334 3.08398 23.1028 3.08398 16.0001C3.08398 8.89735 8.65796 3.16675 15.5007 3.16675C22.3433 3.16675 27.9173 8.89735 27.9173 16.0001Z",
    stroke: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0207 11.4421L13.5541 17.9799C13.5591 17.9927 13.569 18.0029 13.5816 18.0081L19.9123 20.622C19.9529 20.6388 19.9939 20.5988 19.978 20.5578L17.4446 14.0199C17.4396 14.0071 17.4297 13.997 17.417 13.9917L11.0864 11.3778C11.0458 11.361 11.0048 11.4011 11.0207 11.4421Z",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7923 14.6667L14.209 17.3334",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 10V6.12347C13.5625 6.07854 13.6172 6.05641 13.6484 6.08868L17.3516 9.91132C17.3828 9.94359 17.4375 9.92146 17.4375 9.87653V6",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 22H14.3407C13.9109 22 13.5625 22.3484 13.5625 22.7782V22.7782C13.5625 23.1103 13.7734 23.4059 14.0875 23.514L16.9125 24.486C17.2266 24.5941 17.4375 24.8897 17.4375 25.2218V25.2218C17.4375 25.6516 17.0891 26 16.6593 26H13.5625",
    stroke: "#DADADA",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassOutlined);
export default __webpack_public_path__ + "static/media/compass-outlined.f07aed88991dc42bea011362e20dd53b.svg";
export { ForwardRef as ReactComponent };